import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3043ec63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "price-block__title" }, " Расценки ", -1 /* HOISTED */))

import pSwitch from '@/common/pSwitch/pSwitch.vue'
import DigitalBlock from "@/searchSection/components/SearchPanel/DigitalBlock.vue";
import {useSearchStore} from "@/searchSection/store/searchStore";
import {computed} from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PriceBlock',
  setup(__props) {

const searchStore = useSearchStore()

const twoHourLabel = computed(() => {
  return searchStore.searchOptions.priceInfo.isNight ? 'Ночь' : '2 часа'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(pSwitch, {
      modelValue: _unref(searchStore).searchOptions.priceInfo.typeChecked,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchStore).searchOptions.priceInfo.typeChecked) = $event)),
      firstLabel: "Апартаменты",
      secondLabel: "Выезд"
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createVNode(pSwitch, {
      modelValue: _unref(searchStore).searchOptions.priceInfo.isNight,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchStore).searchOptions.priceInfo.isNight) = $event)),
      firstLabel: "День",
      secondLabel: "Ночь"
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createVNode(DigitalBlock, {
      first: _unref(searchStore).searchOptions.priceInfo.oneHour.from,
      "onUpdate:first": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).searchOptions.priceInfo.oneHour.from) = $event)),
      second: _unref(searchStore).searchOptions.priceInfo.oneHour.to,
      "onUpdate:second": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchStore).searchOptions.priceInfo.oneHour.to) = $event)),
      title: '1 час',
      orText: "-",
      firstPlaceholder: 'От ₽',
      secondPlaceholder: 'До ₽'
    }, null, 8 /* PROPS */, ["first", "second"]),
    _createVNode(DigitalBlock, {
      first: _unref(searchStore).searchOptions.priceInfo.twoHour.from,
      "onUpdate:first": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchStore).searchOptions.priceInfo.twoHour.from) = $event)),
      second: _unref(searchStore).searchOptions.priceInfo.twoHour.to,
      "onUpdate:second": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchStore).searchOptions.priceInfo.twoHour.to) = $event)),
      title: twoHourLabel.value,
      orText: "-",
      firstPlaceholder: 'От ₽',
      secondPlaceholder: 'До ₽'
    }, null, 8 /* PROPS */, ["first", "second", "title"])
  ]))
}
}

})